module.exports = __webpack_public_path__ + "img/browser5.341e53fe.png";